import { Injectable } from '@angular/core';
import { NullableIdDto, Rest, RestService } from '@ralba/shared';
import {
  CreateOrUpdateLanguageInput,
  EntityDto,
  FileDto,
  GetLanguageForEditOutput,
  GetLanguagesOutput,
  SetDefaultLanguageInput,
  UploadTranslationInputDto
} from '../dto';


@Injectable({ providedIn: 'root' })
export class LanguageTextManagementHttpApiService {
  constructor(private rest: RestService) { }


  public getLanguages() {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/localization-management/get-languages',
    };
    return this.rest.request<null, Rest.AbpResponse<GetLanguagesOutput>>(request);
  }

  public getLanguageForEdit(params: NullableIdDto) {
    const request: Rest.Request<null> = {
      method: 'GET',
      params,
      url: '/api/localization-management/get-language-for-edit',
    };
    return this.rest.request<null, Rest.AbpResponse<GetLanguageForEditOutput>>(request);
  }

  public createOrUpdateLanguage(body: CreateOrUpdateLanguageInput) {
    const request: Rest.Request<CreateOrUpdateLanguageInput> = {
      method: 'POST',
      body,
      url: '/api/localization-management/create-or-update-language',
    };
    return this.rest.request<CreateOrUpdateLanguageInput, Rest.AbpResponse<null>>(request);
  }

  public setDefaultLanguage(body: SetDefaultLanguageInput) {
    const request: Rest.Request<SetDefaultLanguageInput> = {
      method: 'POST',
      body,
      url: '/api/localization-management/set-default-language',
    };
    return this.rest.request<SetDefaultLanguageInput, Rest.AbpResponse<null>>(request);
  }

  public deleteLanguage(params: EntityDto) {
    const request: Rest.Request<null> = {
      method: 'DELETE',
      params,
      url: '/api/localization-management/delete-language',
    };
    return this.rest.request<null, Rest.AbpResponse<null>>(request);
  }

  public getXlsx() {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/localization-management/get-xlsx',
    };
    return this.rest.request<null, Rest.AbpResponse<FileDto>>(request);
  }

  public uploadXlsx(body: UploadTranslationInputDto) {
    const request: Rest.Request<UploadTranslationInputDto> = {
      method: 'POST',
      url: '/api/localization-management/import-xlsx',
      body
    };
    return this.rest.request<UploadTranslationInputDto, Rest.AbpResponse<null>>(request);
  }

}
